export const SEARCH_REQUEST_TIMEOUT_MS = 5_000;

/** A signal that aborts with the first of `signals` to abort, for browsers without `AbortSignal.any` (Safari < 17.4). */
const anyOf = (signals: readonly AbortSignal[]): AbortSignal => {
  const controller = new AbortController();
  for (const source of signals) {
    if (source.aborted) {
      controller.abort(source.reason);
      break;
    }
    source.addEventListener('abort', () => controller.abort(source.reason), { once: true });
  }
  return controller.signal;
};

export const withRequestTimeout = (signal?: AbortSignal, timeoutMs = SEARCH_REQUEST_TIMEOUT_MS): AbortSignal => {
  const timeout = AbortSignal.timeout(timeoutMs);
  if (!signal) return timeout;
  return typeof AbortSignal.any === 'function' ? AbortSignal.any([signal, timeout]) : anyOf([signal, timeout]);
};
